import { CompetitionLanding, freePlanFaqAnswer, freePlanCreateFaqAnswer } from './CompetitionLanding';
import type { FreeLimits } from '../types';

const config = {
  slug: 'brasileirao',
  routeId: 'pool-brasileirao',
  seoTitle: 'Bolão Brasileirão 2026 — Faça seus palpites grátis | Bolão Elite',
  seoDescription:
    'Crie seu bolão do Campeonato Brasileiro 2026 grátis. Palpite nos placares de todas as rodadas, dispute com amigos e suba no ranking. 100% online, sem download.',
  seoKeywords:
    'bolão brasileirão, bolão campeonato brasileiro, palpites brasileirão 2026, bolão serie a, bolão futebol grátis',
  canonical: 'https://bolaoelite.com.br/bolao-brasileirao',
  heroTitle: 'Bolão do Brasileirão 2026',
  heroSubtitle:
    'Palpite nos placares de todas as 380 rodadas do Campeonato Brasileiro, dispute com amigos e acompanhe o ranking em tempo real.',
  accentColor: 'text-green-600',
  faqs: [
    {
      question: 'O bolão do Brasileirão é gratuito?',
      answer: (limits: FreeLimits) => freePlanFaqAnswer(limits),
    },
    {
      question: 'Quando posso fazer meu palpite?',
      answer: 'Os palpites ficam abertos até o início de cada partida. Assim que o jogo começar, o palpite é bloqueado automaticamente.',
    },
    {
      question: 'Como os pontos são calculados no Brasileirão?',
      answer: 'Você ganha mais pontos acertando o placar exato. Acertar só o resultado (vitória, empate ou derrota) também vale pontos conforme a regra do bolão.',
    },
    {
      question: 'Posso criar um bolão privado para meu grupo de amigos?',
      answer: (limits: FreeLimits) => freePlanCreateFaqAnswer(limits),
    },
    {
      question: 'Qual é o número mínimo de participantes?',
      answer: 'Não há mínimo. Você pode até jogar sozinho para testar, mas o mais divertido é ter amigos competindo!',
    },
  ],
};

export default function LandingBrasileiro() {
  return <CompetitionLanding config={config} />;
}
